import { useSelector } from 'react-redux'

export function useUser () {
  return useSelector((state) => state.user)
}

export function useWorkspacePlan () {
  return useSelector((state) => state.workspaces.workspacePlan)
}

export function useWorkspace () {
  return useSelector((state) => state.workspaces.currentWorkspace)
}

export function useAllWorkspaces () {
  return useSelector((state) => state.workspaces.uniqueWorkspaces)
}

export function usePlan () {
  return useSelector((state) => state.plan)
}
